import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService } from '../utils/config-service';
import { GlobalName } from '../utils/global-name';

@Injectable({
  providedIn: 'root'
})
export class ClassroomService {

  url=ConfigService.toApiUrl("classrooms/");

  constructor(private http:HttpClient) { }

    getAll(){
    return this.http.get<any[]>(`${this.url}`,ConfigService.addAction('list'));
  }
 
  getByState(state:any){
    return this.http.get<any[]>(`${ConfigService.toApiUrl("classrooms-by-state")}/${state}`,ConfigService.addAction('list'));
  }
  getClassroomProfessorList(classroomId:any){
    return this.http.get<any[]>(`${ConfigService.toApiUrl("classrooms-professors-list")}/${classroomId}`,ConfigService.addAction('list'));
  }

  store(ressource:any){
    return this.http.post<any>(`${this.url}`, ressource,
     ConfigService.addAction('add'));
  }

  update(id:any,ressource:any){
    // apiResource n'expose que PUT|PATCH sur /{id}. Le spoofing par _method
    // fonctionne, mais l'affectation d'une propriete sur un FormData ne cree
    // aucun champ : la requete partait alors en POST nu et repondait 405.
    if (ressource instanceof FormData) {
      ressource.append('_method','PUT');
      return this.http.post<any>(`${this.url}${id}`, ressource, ConfigService.addAction('edit'));
    }
    return this.http.put<any>(`${this.url}${id}`, ressource, ConfigService.addAction('edit'));
  }
  delete(id:any){
    return this.http.delete<any>(`${this.url}${id}`,
     ConfigService.addAction('delete'));
  }

  get(id:any){
    return this.http.get<any>(`${this.url}${id}`,
     ConfigService.addAction('show'));
  }

  setState(id:any,state:any){
    return this.http.get<any[]>(`${ConfigService.toApiUrl("classrooms-set-state")}/${id}/state/${state}`,ConfigService.addAction('status'));
  }
  setOut(id:any,state:any){
    return this.http.get<any[]>(`${ConfigService.toApiUrl("classrooms-set-out")}/${id}/state/${state}`,ConfigService.addAction('status'));
  }
}
